import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Musteriler = () => {
  const navigate = useNavigate();
  const { canEdit, canDelete } = useAuth();
  const [musteriler, setMusteriler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchMusteriler();
  }, []);

  const fetchMusteriler = async () => {
    try {
      const response = await axios.get(`${API}/musteriler`);
      const sorted = response.data.sort((a, b) => a.ad.localeCompare(b.ad, 'tr'));
setMusteriler(sorted);
    } catch (error) {
      console.error('Müşteriler yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bu müşteriyi silmek istediğinize emin misiniz?')) {
      try {
        await axios.delete(`${API}/musteriler/${id}`);
        fetchMusteriler();
      } catch (error) {
        console.error('Müşteri silinirken hata:', error);
        alert('Müşteri silinemedi');
      }
    }
  };

  const filteredMusteriler = musteriler.filter(m =>
    m.ad.toLowerCase().includes(searchTerm.toLowerCase()) ||
    m.sehir.toLowerCase().includes(searchTerm.toLowerCase()) ||
    m.vergi_no.includes(searchTerm)
  );

  if (loading) {
    return <div className="loading" data-testid="loading">Yükleniyor...</div>;
  }

  return (
    <div data-testid="customers-page">
      <div className="page-header">
        <h1 className="page-title">Müşteriler</h1>
        <p className="page-subtitle">Müşteri kayıtlarını görüntüleyin ve yönetin</p>
      </div>

      <div style={{ marginBottom: '24px', display: 'flex', gap: '12px' }}>
        <input
          type="text"
          placeholder="Müşteri adı, şehir veya vergi no ile ara..."
          className="form-input"
          style={{ flex: 1 }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          data-testid="search-input"
        />
        {canEdit() && (
          <button className="btn btn-primary" onClick={() => navigate('/musteriler/yeni')} data-testid="add-customer-btn">
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Yeni Müşteri
          </button>
        )}
      </div>

      {filteredMusteriler.length === 0 ? (
        <div className="empty-state" data-testid="empty-state">
          <h3>Henüz müşteri kaydı yok</h3>
          <p>Yeni müşteri eklemek için yukarıdaki butona tıklayın</p>
        </div>
      ) : (
        <div className="card">
          <table className="table" data-testid="customers-table">
            <thead>
              <tr>
                <th>Müşteri Adı</th>
                <th>Temsilci</th>
                <th>Telefon</th>
                <th>Şehir</th>
                <th>Vergi No</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {filteredMusteriler.map(musteri => (
                <tr key={musteri.id} data-testid={`customer-row-${musteri.id}`}>
                  <td style={{ fontWeight: 600 }}>{musteri.ad}</td>
                  <td>{musteri.temsilci}</td>
                  <td>{musteri.telefon}</td>
                  <td>{musteri.sehir}</td>
                  <td>{musteri.vergi_no}</td>
                  <td>
                    <div className="action-buttons">
                      {canEdit() && (
                        <button className="icon-btn" onClick={() => navigate(`/musteriler/${musteri.id}`)} data-testid={`edit-customer-${musteri.id}`}>
                          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                          </svg>
                        </button>
                      )}
                      {canDelete() && (
                        <button className="icon-btn danger" onClick={() => handleDelete(musteri.id)} data-testid={`delete-customer-${musteri.id}`}>
                          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Musteriler;